<template>
    <div id="editDashboardPage" class="baseTemplate">
        <!-- begin:: mobile menu -->
        <app-mobilemenu></app-mobilemenu>
        <!-- end:: mobile menu -->

        <div class="kt-grid kt-grid--hor kt-grid--root">
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                <!-- begin:: home menu -->
                <app-siteconfigurationmenu activeItem="editDashboard"></app-siteconfigurationmenu>
                <!-- end:: home menu -->

                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
                    <!-- begin:: header -->
                    <app-header></app-header>
                    <!-- end:: header -->

                    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                        <!-- begin:: Content Head -->
                        <div class="kt-subheader kt-grid__item">
                            <app-sitetitle subHeaderDescKey="analytics_editDashboardSubTitle"></app-sitetitle>
                        </div>
                        <!-- end:: Content Head -->

                        <!-- begin:: Content -->
                        <div class="kt-content kt-grid__item kt-grid__item--fluid">
                            <!-- begin:: Content -->

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="kt-portlet">
                                        <div class="kt-portlet__head">
                                            <div class="kt-portlet__head-label">
                                                <span class="kt-portlet__head-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24" />
                                                            <path d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z" fill="#000000" fill-rule="nonzero" />
                                                            <path d="M8.7295372,14.6839411 C8.35180695,15.0868534 7.71897114,15.1072675 7.31605887,14.7295372 C6.9131466,14.3518069 6.89273254,13.7189711 7.2704628,13.3160589 L11.0204628,9.31605887 C11.3857725,8.92639521 11.9928179,8.89260288 12.3991193,9.23931335 L15.358855,11.7649545 L19.2151172,6.88035571 C19.5573373,6.44687693 20.1861655,6.37289714 20.6196443,6.71511723 C21.0531231,7.05733733 21.1271029,7.68616551 20.7848828,8.11964429 L16.2848828,13.8196443 C15.9333973,14.2648593 15.2823707,14.3288915 14.8508807,13.9606866 L11.8268294,11.3801628 L8.7295372,14.6839411 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                                        </g>
                                                    </svg>
                                                </span>
                                                <h3 class="kt-portlet__head-title">
                                                    {{ $t("analytics_editDashboard") }}
                                                </h3>
                                            </div>
                                        </div>

                                        <!--begin::Form-->
                                        <form class="kt-form" novalidate="novalidate">
                                            <div class="kt-portlet__body">
                                                <div class="form-group validated">
                                                    <label for="editDashboardForm_nameInput">{{ $t("analytics_dashboardName") }} *</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text"><i class="la la-pencil"></i></span>
                                                        </div>
                                                        <input v-model="name" @input="$v.name.$touch()" @keyup="onChangeForm" type="text" class="form-control" id="editDashboardForm_nameInput" :placeholder="$t('analytics_dashboardNameInputInfo')" />
                                                        <div v-if="!$v.name.required" class="invalid-feedback">
                                                            {{ $t("error_fieldIsRequired") }}
                                                        </div>
                                                        <div v-else-if="!$v.name.minLen" class="invalid-feedback">
                                                            {{ $t("error_minLengthMsg", [$v.name.$params.minLen.min]) }}
                                                        </div>
                                                    </div>
                                                    <span class="form-text text-muted"> {{ $t("analytics_dashboardNameDetailInfo") }}</span>
                                                </div>
                                                <div class="form-group form-group-last validated">
                                                    <label for="editDashboardForm_selectRefreshInterval">{{ $t("analytics_dashboardRefreshInterval") }}</label>
                                                    <!-- <input class="form-control" type="number" id="editDashboardForm_refreshIntervalInput" v-model="refreshInterval" rows="3" min="10" @change="onChangeForm" /> -->
                                                    <select class="form-control" id="editDashboardForm_selectRefreshInterval" v-model="refreshInterval" @change="onChangeForm">
                                                        <option value="10"> {{ $tc("analytics_RI_seconds", 10) }}</option>
                                                        <option value = "30">{{ $tc("analytics_RI_seconds", 30) }}</option>
                                                        <option value="60">{{ $tc("analytics_RI_minutes") }} </option>
                                                        <option value="180">{{ $tc("analytics_RI_minutes", 3) }} </option>
                                                        <option value="600">{{ $tc("analytics_RI_minutes", 10) }} </option>
                                                        <option value="3600">{{ $tc("analytics_RI_hours", 1) }} </option>
                                                    </select>
                                                    <div v-if="invalidRI" class="invalid-feedback">
                                                        {{ $t("analytics_dashboardRIError") }}
                                                    </div>
                                                    <span class="form-text text-muted"> {{ $t("analytics_dashboardRIDetailInfo") }}</span>
                                                </div>
                                            </div>
                                            <div class="kt-portlet__foot">
                                                <div class="kt-form__actions kt-form__actions--right">
                                                    <button id="editDashboardUpdateButton" @click="onUpdateButton" type="button" class="btn btn-brand kt-margin-r-5" :disabled="$v.$invalid || !isFormDataChanged || invalidRI">
                                                        <i class="la la-save"></i>
                                                        {{ $t("common_saveChanges") }}
                                                    </button>
                                                    <button id="editDashboardCancelButton" @click="onCancelButton" type="button" class="btn btn-secondary">{{ $t("common_cancel") }}</button>
                                                </div>
                                            </div>
                                        </form>
                                        <!--end::Form-->
                                    </div>
                                </div>
                            </div>

                            <!-- end:: Content -->
                        </div>
                        <!-- end:: Content -->
                    </div>

                    <!-- begin:: Footer -->
                    <app-footer></app-footer>
                    <!-- end:: Footer -->
                    <!-- begin:: Modal to confirm leave page -->
                    <app-confirmleavepagemodal ref="confirmleavepagemodalref"></app-confirmleavepagemodal>
                    <!-- end::Modal -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import SiteTitle from "./../site/widgets/sitetitle.vue";
import commonVueHelper from "../../helpers/commonVueHelper";

export default {
    data() {
        return {
            name: "",
            refreshInterval: 30,
            siteId: this.$route.params.siteId,
            dashboardId: this.$route.params.dashboardId,
            isFormDataChanged: false,
            invalidRI: false
        };
    },
    created: function() {
        console.log("Component(editDashboard)::created() - called");
        const payload = {
            siteId: this.siteId,
            dashboardId: this.dashboardId
        };
        this.getDashboardById(payload);
    },
    mounted: function() {
        console.log("Component(editDashboard)::mounted() - Init metronic layout");
        KTLayout.init();
    },
    destroyed: function() {
        console.log("Component(editDashboard)::destroyed() - called");
        this.resetDashboardsState();
    },
    validations: {
        // -- validations -- List of controls to apply to validate a form.
        // --
        name: {
            required,
            minLen: minLength(2)
        }
    },
    watch: {
        // -- Watch -- Property to perform asynchronous or expensive operations in response to changing component "data".
        // --
        currentDashboard: function(dashboard) {
            console.log("Component(editDashboard)::watch currentDashboard - called");
            if (dashboard) {
                this.name = dashboard.name;
                this.refreshInterval = dashboard.refreshInterval;
            }
        }
    },
    computed: {
        // -- Computed -- Property will only re-evaluate when some of its reactive dependencies have changed.
        // To compose new data from existing datasource
        // To reference a value from the template (cached value)
        // --
        ...mapGetters(["currentSite", "currentDashboard"])
    },
    methods: {
        // -- Methods -- Property to perform an action.
        // To react on some event happening in the DOM (called every time an event occurs even if method returns the same result)
        // To call a function when something happens in your component (from property "computed" or "watch")
        // ---
        ...mapActions(["getDashboardById", "updateDashboard", "resetDashboardsState"]),

        // Function called when user click on the "Cancel" button
        onCancelButton() {
            console.log("Component(editDashboard)::onCancelButton() - called");
            this.$router.push({ name: "dashboards", params: { fromAction: "cancelButton" } });
        },

        onUpdateButton() {
            console.log("Component(editDashboard)::onUpdateButton() - called");
            var data = {
                siteId: this.siteId,
                dashboardId: this.dashboardId,
                name: this.name,
                refreshInterval: parseInt(this.refreshInterval),
                stayOnPage: false
            };
            this.updateDashboard(data);
        },

        onChangeForm() {
            this.invalidRI = ![10, 30, 60, 180, 600, 3600].includes(parseInt(this.refreshInterval));
            this.isFormDataChanged = true;
        }
    },
    components: {
        // -- Components -- List of local components used in the current template
        // --
        "app-sitetitle": SiteTitle
    },

    beforeRouteLeave(to, from, next) {
        // -- Called when the route that renders this component is about to be navigated away from.
        // --
        commonVueHelper.displayConfirmModalOnLeavePage(this, "EditDashboard", "update", this.isFormDataChanged, to, from, next);
    }
};
</script>

<style scoped>
.baseTemplate {
    display: contents;
}
</style>
